var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar__block sidebar__block--green"},[_c('div',[_vm._v(_vm._s(_vm.scope))]),_vm._v(" "),_c('div',[_vm._v("В пути")])])}
var staticRenderFns = []

export { render, staticRenderFns }